import { render } from "./VisitorGeneralSettings.vue?vue&type=template&id=50ebc790"
import script from "./VisitorGeneralSettings.vue?vue&type=script&lang=js"
export * from "./VisitorGeneralSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__